import PropTypes from 'prop-types';
import { creatorType } from '~/types/creator';

export const NotificationType = PropTypes.shape({
  createdAt: PropTypes.string.isRequired,
  creator: creatorType.isRequired,
  id: PropTypes.string.isRequired,
  manager: PropTypes.shape({ id: PropTypes.string }),
  params: PropTypes.oneOfType([
    PropTypes.shape({ contentId: PropTypes.string }),
    PropTypes.shape({ milestoneReached: PropTypes.number }),
  ]),
  read: PropTypes.bool.isRequired,
  type: PropTypes.oneOf(['AD_CONTENT_POSTED', 'FOLLOWERS_MILESTONE'])
    .isRequired,
  updatedAt: PropTypes.string.isRequired,
});
